import React, { useState } from 'react'
import './Common_Goto_Cart_Card.css'
import Green_Btn from '../common_btn/green_btn/Green_Btn'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'

const Common_Goto_Cart_Card = ({ inCart, saveTotal, onClose, closeModal }) => {

    const navigate = useNavigate();
    const [isClosing, setIsClosing] = useState(false);

    const handleClose = () => {
        setIsClosing(true);
        if (onClose) onClose();
        if (closeModal) closeModal();

    };

    const data = saveTotal()
   


    return (
        <div className={`GotoCart_container ${isClosing ? "slide-out-left" : ""}`}>

            <div className="goto_cart_card">
                <div className="left_side">
                    <div className="img_holder">
                        <img
                            src={
                                process.env.REACT_APP_IMG_URL +
                                inCart?.image
                            }
                        />
                    </div>

                    <div className="text_holder">
                        <div className="top_heading">
                            <p>{inCart?.name} | ₹ {data?.total} </p>
                        </div>
                        <div className="footer_text">
                            <p>You saved ₹ {data?.savings}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="btn_holder">
                    <div>
                        <Green_Btn btn_name="Go To Cart" onClick={() => { navigate("/cart") }} />
                    </div>

                    <div className="close_div" onClick={handleClose}>
                        <FontAwesomeIcon icon={faXmark} className="close_icon" />
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Common_Goto_Cart_Card
